// extracted by mini-css-extract-plugin
export default {"list":"ContainersWrapper_list__pvrNn","item":"ContainersWrapper_item__14J-G","itemImage":"ContainersWrapper_itemImage__bF4RE","info":"ContainersWrapper_info__gCIfy"};